import { render, staticRenderFns } from "./DownloadForms.vue?vue&type=template&id=432eeeb6&scoped=true&"
import script from "./DownloadForms.vue?vue&type=script&lang=ts&"
export * from "./DownloadForms.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadForms.vue?vue&type=style&index=0&id=432eeeb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432eeeb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VIcon,VImg,VLayout})
